class ModalPopUp extends HTMLElement {
    constructor() {
      super();
      this.modal = this;
      this.close = [...document.querySelectorAll('[data-modal-close]')];
      this.modalVisited = sessionStorage.getItem('Pop Up');
    }

    connectedCallback() {
      this.init();
    }

    init() {
        if(!this.modalVisited){
            setTimeout(() => {
                this.modal.classList.add('active');
                sessionStorage.setItem("Pop Up", "True");
            }, 500);
        }
        this.close.forEach(closeBtn =>
            closeBtn.addEventListener('click', () => {
                this.modal.classList.remove('active');
            })
        );
    }

  }

  customElements.define('modal-pop-up', ModalPopUp);